module.exports = __webpack_public_path__ + "img/6.a46d58d7.jpg";